import { useEffect } from 'react';

/**
 * Custom hook to lock body scroll when a modal is open
 * @param {boolean} isOpen - Whether the modal is open
 */
export const useLockBodyScroll = (isOpen) => {
    useEffect(() => {
        if (isOpen) {
            // Get current scroll position
            const scrollY = window.scrollY;
            
            // Store original body styles
            const originalStyle = {
                overflow: document.body.style.overflow,
                position: document.body.style.position,
                top: document.body.style.top,
                width: document.body.style.width
            };
            
            // Lock the scroll
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            
            // Cleanup function
            return () => {
                // Restore original styles
                document.body.style.overflow = originalStyle.overflow;
                document.body.style.position = originalStyle.position;
                document.body.style.top = originalStyle.top;
                document.body.style.width = originalStyle.width;
                
                // Restore scroll position
                window.scrollTo(0, scrollY);
            };
        }
    }, [isOpen]);
};

export default useLockBodyScroll;
